import React,{useEffect,useState} from "react";
import { Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Form } from "react-final-form";
import * as yup from "yup";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import UiInput from "../../../../../../_uiComponents/UiInput";

import {
     UiButton,
} from "../../../../../../_uiComponents/common/form/UiButton";
import Validator from "../../../../../../../_helpers/validate.schema";
import PublishedTable from "../PublishedTable";
import FaqPreview from "./FaqPreview";
import { incentiveFaqContentAddRequest, incentiveFaqPublishedRevisionRequest } from "../../../../../../../_redux/_actions";

const getSectionsArray = ()=>{
     let divIds = Array.from(document.querySelectorAll('[id^="faqSection"]')).map(element => element.id);
     return divIds;
}

const validateSchema = () => {

     let schema = yup.object().shape({
          MenuTitle: yup.string().max(50, 'tile characters are more than 50'),
          Title: yup.string().max(50, 'tile characters are more than 50'),
          changeReason: yup.string().max(50, 'tile characters are more than 50'),
     });

     for (let i =  0; i <= getSectionsArray().length; i++) {

          schema = schema.shape({
               [`faqTitle${i}`]: yup.string().max(50, 'tile characters are more than 50'),
               [`Description${i}`]: yup.string().max(2500, 'tile characters are more than 2500'),
             });

        }

     return schema;
}
     

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function FAQContentFrom(props) {

     const actionDispatch = useDispatch();

     const { id } = useParams();
     const [FAQList,setFAQList] = React.useState([]);
     const [initialValuesList,setInitialValuesList] = useState({});


     useEffect(()=>{
          FAQList.push({
               id:FAQList.length
          });
     },[]);

     useEffect(()=>{

          actionDispatch(
               incentiveFaqPublishedRevisionRequest({
                    campaignId:props.campaignId
               }),
          );

     },[]);


     const {contentFaqDetails,publishedData } = useSelector(
          (state) => {
               return {
                    publishedData:state.incentive.contentFaqRevisionPublished,
                    contentFaqDetails:state.incentive.contentFaqDetails,
               };
          },
     );


     useEffect(()=>{

          let tempObj = {};
          let rowObj = {};
          let tempArray = FAQList;

          if(contentFaqDetails?.MenuTitle){

               if(FAQList.length>0){
                    FAQList.pop();
               }
              
               tempObj.menuTitle = contentFaqDetails.MenuTitle;
               tempObj.title = contentFaqDetails.Title;
               tempObj.changeReason = contentFaqDetails.ChangeReason ?? "";

               for (let index = 0; index < contentFaqDetails.IncentiveCampaignContentFaqItemDtos.length; index++) {
                   
                    rowObj = contentFaqDetails.IncentiveCampaignContentFaqItemDtos[index];

                    tempObj[`faqTitle${index}`] = rowObj.title;
                    tempObj[`Description${index}`] = rowObj.description;
                    tempObj[`Active${index}`] = rowObj.active;

                    tempArray.push(rowObj);
                    
               }

               setFAQList(tempArray);
               setInitialValuesList(tempObj);

          }

     },[contentFaqDetails]);


     const saveData = async (values,form) => {

        
          let finalPayload = {
               id: id,
               MenuTitle: values.MenuTitle,
               Title: values.Title,
               IncentiveCampaignContentFaqItemDtos: [],
               changeReason: values.changeReason,
               page: 1,
               pageSize: 5,
               form,
          };


          let sectionArray = getSectionsArray();

          await sectionArray.forEach(e => {

               let index = e.split('faqSection')[1];

               let tempArr = {
                    Title:values[`faqTitle${index}`],
                    Description:values[`Description${index}`],
                    Active:values[`Active${index}`],

               };

               finalPayload.IncentiveCampaignContentFaqItemDtos.push(tempArr);
               
          });


          actionDispatch(incentiveFaqContentAddRequest(finalPayload));
          
          
     }

     const submit = async () => {

          let tempList = FAQList;

               tempList.push({
                    id:tempList.length
               });

          setFAQList(tempList);
          
      };

      const clearData = (index)=>{

         var element = document.getElementById("faqSection"+index);
          element.parentNode.removeChild(element);
          
        
      }

     return (
          <Form
               onSubmit={submit}
               validate={onValidate}
               initialValues={initialValuesList}
               render={({ form, handleSubmit,values,errors }) => {
                    return (
                         <form onSubmit={validateSchema}>
                              <div className="sbm-content-section">
                                   <Grid container spacing={2} sx={{ mb: 1, mt: 1 }}>
                                        <Grid item xs={12} lg={6}>
                                             <UiInput
                                                  type="text"
                                                  label="Menu Title"
                                                  name="MenuTitle"
                                             />
                                        </Grid>
                                   </Grid>
                                   <Grid container spacing={2} sx={{ mb: 1 }}>
                                        <Grid item xs={12} lg={6}>
                                             <UiInput
                                                  type="text"
                                                  label="Title"
                                                  name="Title"
                                             />
                                        </Grid>
                                   </Grid>

                                   {FAQList.map((e,index)=>{
                                         return <FaqPreview faq={e} indexNo={index} clearDataFunc={clearData} />
                                   })}
                                   
                                   <Grid
                                        item
                                        xs={12}
                                        lg={12}
                                        sx={{ mb: 2 }}
                                   >
                                        <Stack
                                             spacing={2}
                                             direction="row"
                                             justifyContent="start"
                                             sx={{ width: "100%" }}
                                        >
                                             <Button
                                                  variant="contained"
                                                  color="success"
                                                  startIcon={
                                                       <ControlPointIcon />
                                                  }
                                                  onClick={()=>{
                                                       handleSubmit();
                                                  }}
                                             >
                                                  Add
                                             </Button>

                                        </Stack>
                                   </Grid>
                                   <Grid container spacing={2}>
                                        <Grid
                                             item
                                             xs={12}
                                             lg={6}
                                             sx={{ mt: 2 }}
                                             className='sba-campaign-content-text-bg'
                                        >
                                             <UiInput
                                                  type="text"
                                                  name="changeReason"
                                                  multiline={true}
                                                  minRows={3}
                                                  maxRows={5}
                                                  label="Change Reason"
                                             />

                                        </Grid>
                                        <Grid
                                             item
                                             xs={12}
                                             lg={12}
                                             sx={{ mb: 2, mt: 6 }}
                                        >
                                             <Stack
                                                  spacing={2}
                                                  direction="row"
                                                  justifyContent="end"
                                                  sx={{ width: "100%" }}
                                             >
                                                  <UiButton
                                                       name="Clear"
                                                       variant="outlined"
                                                       size="small"
                                                       onClick={()=>{
                                                            form.reset();
                                                            setInitialValuesList({});
                                                       }}
                                                  />
                                                  <UiButton
                                                       name="Save"
                                                       variant="contained"
                                                       size="small"
                                                       onClick={()=>{
                                                            if(Object.keys(errors).length === 0){
                                                              saveData(values,form);
                                                            }
                                                         }}
                                                  />
                                             </Stack>
                                        </Grid>
                                        <Grid
                                             item
                                             xs={12}
                                             lg={12}

                                        >
                                             <div className="sba-revison-publish-table">
                                                  <label class="sba-content-label">Published Revision Content</label>
                                                  <PublishedTable loadFaqRevisionData={props.loadFaqRevisionData} publishedData={publishedData} />
                                             </div>

                                        </Grid>
                                   </Grid>

                              </div>
                         </form>
                    );
               }}
          />
     );
}
